import './App.css';
import {Contact, Footer, Hero, Navbar, Projects, Technologies} from './components';

function App() {
  return (
    <div>
      <Navbar/>
      <Hero/>
      <Projects/>
      <Technologies/>
      <Contact/>
      <Footer/>
    </div>
  );
}

export default App;
